import React from 'react';

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

import {
  ColorInput as ColorInputBase,
  IconInput as IconInputBase,
} from '../../Components/Inputs';
import { DialogoCreateEdit } from '../../Components/modulo-gerencial-dialogos';
import {
  TextInput,
  SwitchInput,
} from '../../Components/modulo-gerencial-formularios';
import ControllerInput from '../../Components/modulo-gerencial-formularios/inputs/ControllerInput';

const validadores = {
  nome: (value) => {
    if (!value || value.length < 1) return 'Este campo é obrigatório';
    if (value.length > 80) return 'Não pode ser maior que 80 caracteres';
    return '';
  },
  color: () => '',
  icon: () => '',
  contabiliza_no_lucro: () => '',
  tipo: () => '',
};

const transformGetDados = (dados) => ({
  nome: dados.nome,
  color: dados.color,
  icon: dados.icon,
  contabiliza_no_lucro: dados.contabiliza_no_lucro,
  tipo: dados.tipo,
});

const transformSalvar = (dados, config) => {
  const payload = {
    nome: dados.nome,
    color: dados.color,
    icon: dados.icon,
    contabiliza_no_lucro: dados.contabiliza_no_lucro,
  };
  return payload;
};

function Form() {
  return (
    <div>
      <TextInput name="nome" fullWidth label="Nome" autoFocus />
      <div style={{ marginTop: '20px' }}>
        <div
          style={{
            marginBottom: '8px',
            fontSize: '0.875rem',
            color: 'rgba(0,0,0,0.6)',
          }}
        >
          Cor da categoria
        </div>
        <ControllerInput
          name="color"
          adapterValueOnChange={(value) => value}
          render={({ field }) => (
            <ColorInputBase value={field.value} onChange={field.onChange} />
          )}
        />
      </div>
      <div style={{ marginTop: '24px' }}>
        <div
          style={{
            marginBottom: '8px',
            fontSize: '0.875rem',
            color: 'rgba(0,0,0,0.6)',
          }}
        >
          Ícone
        </div>
        <ControllerInput
          name="icon"
          adapterValueOnChange={(value) => value}
          render={({ field }) => (
            <IconInputBase value={field.value} onChange={field.onChange} />
          )}
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <SwitchInput
          name="contabiliza_no_lucro"
          label={
            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AttachMoneyIcon fontSize="small" />
              Incluir no lucro
            </span>
          }
        />
      </div>
    </div>
  );
}

const Dialogo = ({ onClose, open, id, tipo = 'Despesa' }) => {
  const initialValues = {
    nome: '',
    color: tipo === 'Receita' ? '#4caf50' : '#f44336',
    icon: 'search',
    contabiliza_no_lucro: false,
    tipo,
    gerenciado: false,
  };

  return (
    <DialogoCreateEdit
      open={open}
      id={id}
      initialValues={initialValues}
      validators={validadores}
      resource="categorias_transacao"
      titleCreate={`Nova Categoria de ${tipo}`}
      titleUpdate={`Editar Categoria de ${tipo}`}
      onClose={onClose}
      transformGetDados={transformGetDados}
      transformSalvar={transformSalvar}
      isCloseTitle
    >
      <Form />
    </DialogoCreateEdit>
  );
};

export default Dialogo;
